import { useQuery } from '@apollo/client';
import type { UseOrganizationApiKeysFetch } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes.ts';
import { GetOrgApiKeysDocument } from '../../../graphql/query/organizations/GetOrgApiKeys.generated.tsx';

export const useOrganizationApiKeysFetch: UseOrganizationApiKeysFetch = organizationId => {
  const {
    data: { user: apiKeys = [] } = {},
    error: getKeysError,
    loading: keysLoading,
  } = useQuery(GetOrgApiKeysDocument, {
    variables: { organizationId },
    fetchPolicy: 'no-cache',
  });

  return {
    apiKeys,
    error: getKeysError,
    loading: keysLoading,
  };
};
